import React, { useState, useContext, useCallback } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AppSettings } from "../config/app-settings.js";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../_store";
import registerSchema from "../validation/registerSchema.js";
import background from "../assets/images/banner-img-new.jpg";
import Logo from "../assets/dr_inmate_logo.png";
import { useEffect } from "react";
import { showAlert } from "../components/common/showAlert.js";
import useFullPageLoader from "../hooks/useFullPageLoader";
import PasswordField from "../components/common/UI/Inputs/InputControls/PasswordTextbox.jsx";
import { base64DecryptData } from "../utils/encryptDecrypt.js";
import { myAccountActions, changePasswordActions } from "../_store";
import changePasswordSchema from "../validation/changePasswordSchema.js";
import { encryptData } from "../utils/encryptDecrypt.js";
import ConfirmationModal from "../components/PopupComponent/ConfirmationModal.jsx";
import { EventLog } from "../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../utils/routeTracker.js";
import useIPAddress from "../hooks/useIPAddress.jsx";
import useBrowserType from "../hooks/useBrowserType.jsx";


function ChangePassword() {
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const browser = useBrowserType();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { updatePasswordStatus } = useSelector((state) => state.changePassword || {});
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const ip = useIPAddress();
  const [showModal, setShowModal] = useState(false);

  const [modalContent, setModalContent] = useState({
    title: "",
    messageHTML: "",
    message: "",
    showCancelButton: true,
    closeButton: true,
    onConfirm: () => { },
    onCancel: () => { }
  });

  const [changePassword, setChangePassword] = useState({
    mangementUserID: 0,
    oldPassword: "",
    newPassword: "",
    isSucced: 0,
    confirmPassword: "",
    publicUserID: 0,
    email: "",
    passwordChangeType: 1,
    isSALoginAsPU: 0,
    browserType: "",
    ipAddress: "",
  });

  // Select LoadPublicUserDetails from the Redux store
  const myAccountDetails = useSelector(
    (state) => state.myAccount.LoadPublicUserDetails
  );



  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      const ipAddress = ip;
      const browserType = browser;

      // Grouping the state updates to avoid conflicts
      if (isMounted) {
        setChangePassword((prevForm) => ({
          ...prevForm,
          ipAddress: ipAddress,
          browserType: browserType,
        }));
      }
    };

    fetchData();

    return () => {
      isMounted = false; // cleanup on unmount
    };
  }, [browser, ip]); // Add dependencies for  getBrowserType

  useEffect(() => {
    hideLoader();
    if (myAccountDetails && typeof myAccountDetails === "object") {
      setChangePassword((prevState) => ({
        ...prevState,
        email: myAccountDetails.Email || "",
        oldPassword: myAccountDetails.UserPassword || "",
        publicUserID: myAccountDetails.PublicUserID || 0,
      }));
    }
  }, [myAccountDetails]);

  useEffect(() => {
    // Extract query parameters
    const searchParams = new URLSearchParams(location.search);
    const userID = searchParams.get("UserId");

    // Show success message if UserID
    if (userID !== undefined && userID !== null) {
      const user = base64DecryptData(userID);
      showLoader();
      dispatch(myAccountActions.LoadPublicUserDetails(user));
    }
  }, [location]);

  // Get Change/ Update password status
  useEffect(() => {
    hideLoader();
    if (updatePasswordStatus === 1) {
      setModalContent({
        title: "Reset Password",
        messageHTML: ``,
        message: "Password Updated successful!",
        showCancelButton: false,
        onConfirm: () => {
          navigate("/public/Login");
          storeCurrentRoute("/public/Login");
        }
      });
      const infoMessage = "CHANGE PASSWORD";
      const Status = "Password Updated successful!";
      const Response = updatePasswordStatus;
      const redirectURL = "public/Login";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      setShowModal(true);
      handleReset();
    }
    else if (updatePasswordStatus === -7) {
      setModalContent({
        title: "Reset Password",
        messageHTML: ``,
        message: "Your E-mail has been updated, so this reset link is no longer valid. Please request a new password reset link.",
        showCancelButton: false,
        closeButton: false,
        onConfirm: () => {
          navigate("/public/Login");
          storeCurrentRoute("/public/Login");
        }
      });
      const infoMessage = "CHANGE PASSWORD";
      const Status = "Your E-mail has been updated, so this reset link is no longer valid. Please request a new password reset link.";
      const Response = updatePasswordStatus;
      const redirectURL = "public/Login";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      setShowModal(true);
      handleReset();
    }
    else if (updatePasswordStatus === -1) {
      setModalContent({
        title: "Reset Password",
        messageHTML: ``,
        message: "Operation Failed!",
        showCancelButton: false,
        onConfirm: () => {
          setShowModal(false);
        }
      });
      const infoMessage = "CHANGE PASSWORD";
      const Status = "Operation Failed!";
      const Response = updatePasswordStatus;
      const redirectURL = "public/Login";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      setShowModal(true);
    }
    else if (updatePasswordStatus === -2) {
      setModalContent({
        title: "Reset Password",
        messageHTML: ``,
        message: "Reset Password Mail Already Expired!",
        showCancelButton: false,
        onConfirm: () => {
          setShowModal(false);
        }
      });
      const infoMessage = "CHANGE PASSWORD";
      const Status = "Reset Password Mail Already Expired!";
      const Response = updatePasswordStatus;
      const redirectURL = "public/Login";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      setShowModal(true);
    } else if (updatePasswordStatus === -3) {
      setModalContent({
        title: "Reset Password",
        messageHTML: ``,
        message: "Account is Deactivated!",
        showCancelButton: false,
        onConfirm: () => {
          setShowModal(false);
        }
      });
      const infoMessage = "CHANGE PASSWORD";
      const Status = "Account is Deactivated!";
      const Response = updatePasswordStatus;
      const redirectURL = "public/Login";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      setShowModal(true);
    }
    else if (updatePasswordStatus === -4) {
      setModalContent({
        title: "Reset Password",
        messageHTML: ``,
        message: "Account is Not Yet Activated!",
        showCancelButton: false,
        onConfirm: () => {
          setShowModal(false);
        }
      });
      const infoMessage = "CHANGE PASSWORD";
      const Status = "Account is Not Yet Activated!";
      const Response = updatePasswordStatus;
      const redirectURL = "public/Login";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      setShowModal(true);
    }
    else if (updatePasswordStatus === -5) {
      setModalContent({
        title: "Reset Password",
        messageHTML: ``,
        message: "Invalid Account or Account Blocked!",
        showCancelButton: false,
        onConfirm: () => {
          setShowModal(false);
        }
      });
      const infoMessage = "CHANGE PASSWORD";
      const Status = "Invalid Account or Account Blocked!";
      const Response = updatePasswordStatus;
      const redirectURL = "public/Login";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      setShowModal(true);
    }
    else if (updatePasswordStatus === -6) {
      setModalContent({
        title: "Reset Password",
        messageHTML: ``,
        message: "User ID and E-mail is Empty",
        showCancelButton: false,
        onConfirm: () => {
          setShowModal(false);
        }
      });
      const infoMessage = "CHANGE PASSWORD";
      const Status = "User ID and E-mail is Empty";
      const Response = updatePasswordStatus;
      const redirectURL = "public/Login";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      setShowModal(true);
    }
    hideLoader();
  }, [updatePasswordStatus]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setChangePassword((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Validate a specific field in the form data
  const validateForm = (formData, fieldName = null) => {
    setErrors({});

    // Remove error class from inputs
    document.querySelectorAll(".input-error").forEach((element) => {
      element.classList.remove("input-error");
    });

    // Validate the whole form if no specific field is provided
    const { error } = changePasswordSchema(formData);
    if (error?.details) {
      error.details.forEach((err) => {
        const { path } = err;

        // Check if the error is for the specific field
        if (!fieldName || path[0] === fieldName) {
          setErrors((prev) => ({
            ...prev,
            [path[0]]: err.message,
          }));

          // Add error class to input
          document
            .querySelector(`input[name=${path[0]}]`)
            ?.classList?.add("input-error");
        }
      });
      return false;
    }
    return true;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm(changePassword)) {
      // Stop if there are validation errors
      return;
    }
    showLoader();
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get("Email") !== undefined && searchParams.get("Email") !== null) {
      const oldEmail = base64DecryptData(searchParams.get("Email"));

      const newPassword = encryptData(changePassword?.newPassword);
      const oldPassword = encryptData(changePassword?.oldPassword);
      const updatedLoginForm = {
        ...changePassword, newPassword: newPassword,
        oldPassword: oldPassword, confirmPassword: newPassword, oldEmail: oldEmail
      };
      dispatch(
        changePasswordActions.updatePassword(updatedLoginForm)
      );
    }
  };

  // Handle reset action
  const handleReset = () => {
    setShowPassword(false);
    setShowConfirmPassword(false);
    setChangePassword({
      mangementUserID: 0,
      oldPassword: "",
      newPassword: "",
      isSucced: 0,
      confirmPassword: "",
      publicUserID: 0,
      email: "",
      passwordChangeType: 1,
      isSALoginAsPU: 0,
      browserType: "",
      ipAddress: "",
    });
    const infoMessage = "Clear Input Fields";
    const Status = " --- ";
    const Response = " --- ";
    const redirectURL = "---";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
  };

  return (
    <div className="register register-with-news-feed">
      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={modalContent.onConfirm}
        title={modalContent.title}
        messageHTML={modalContent.messageHTML}
        message={modalContent.message}
        showCancelButton={modalContent.showCancelButton}
        onconfirmname="OK"
        oncancelname=""
        size="md p-4"
        closeButton={modalContent.closeButton}
      />

      <div className="news-feed">
        <div
          className="news-image"
          style={{
            backgroundImage: `url(${background})`,
          }}
        ></div>
        <div className="news-caption">
          <h1 className="text-white font-xl">
            <b>INMATE INBOX</b>
          </h1>
          <p className="font-size-20">
            Send & Receive Secure Electronic Messages With Your{" "}
            <span className="default-color">Loved</span> Ones. There’s no better
            way to stay connected with your loved one or friend than real time
            messages.
          </p>
        </div>
      </div>
      <div className="register-container">
        <div className="login-header mb-30px">
          <div className="brand">
            <div
              className="d-flex align-items-center"
              style={{ justifyContent: "center" }}
            >
              <img src={Logo} className="login-logo" alt=""></img>
            </div>
          </div>
        </div>
        <div className="register-header mb-25px h1">
          <div className="mb-1">Change Password</div>
        </div>
        <div className="register-content">
          <form className="fs-13px" onSubmit={handleSubmit}>
            <div className="mb-3">
              <div className="row mb-3">
                <div className="col-12 mb-2">
                  <PasswordField
                    name="newPassword"
                    id="newPassword" // Ensure the id matches
                    label="New Password" // Pass the label text here
                    //   placeholder="Password"
                    value={changePassword.newPassword}
                    onChange={handleChange}
                    //  onBlur={handleBlur}
                    errorMessage={errors.newPassword} // Use errorMessage prop
                    required // Mark as required if necessary
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSubmit(e);
                      }
                    }}
                    showPassword={showPassword}
                    setShowPassword={setShowPassword}
                  />
                </div>
                <div className="col-12">
                  <PasswordField
                    name="confirmPassword"
                    id="userPassword" // Ensure the id matches
                    label="Confirm Password" // Pass the label text here
                    // placeholder="Confirm Password"
                    value={changePassword.confirmPassword}
                    onChange={handleChange}
                    //  onBlur={handleBlur}
                    errorMessage={errors.confirmPassword} // Use errorMessage prop
                    required // Mark as required if necessary
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSubmit(e);
                      }
                    }}
                    showPassword={showConfirmPassword}
                    setShowPassword={setShowConfirmPassword}
                  />
                </div>
              </div>
            </div>
            <div className="mb-4">
              <button type="submit" className="btn btn-danger me-5px">
                <i class="fa-solid fa-check me-1"></i>
                Submit
              </button>
              <button
                type="button"
                onClick={handleReset}
                className="btn btn-grey me-5px"
              >
                <i className="fa-solid fa-arrow-rotate-left me-1"></i>

                Reset
              </button>
              {/* <button
                type="button"
                onClick={handleBack}
                className="btn btn-danger w-100px"
              >
                Back
              </button> */}
            </div>
            <div className="mb-4 pb-5">
              Already a member? Click <Link to="/public/Login">here</Link> to
              login.
            </div>
            <hr className="bg-gray-600 opacity-2" />
            <p className="text-center text-gray-600">
              &copy; Inmate Inbox All Right Reserved {new Date().getFullYear()}
            </p>
          </form>
        </div>
      </div>
      {loader}
    </div>
  );
}

export default React.memo(ChangePassword);
